/* eslint-disable react-hooks/exhaustive-deps */
import { KTSVG } from '../../_metronic/helpers'
import React, { useState, useEffect } from 'react'
import { Modal, Table, Button } from 'react-bootstrap-v5';
import Swal from 'sweetalert2'
import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper'
import Select from 'react-select'
import { Link } from 'react-router-dom';
import validationErrorMsg from '../helpers/ValidationErrorMsg'
import { useHistory, useParams } from "react-router-dom";

interface RouteParams {
    idProductions: string;
}

interface ProductBomOption {
    label: string;
    value: number;
}

interface ProductionRows {
    indexKey: number | null;
    idProducts: number;
    idProductBoms?: number | null;
    bomName?: string;
    bomOptions?: ProductBomOption[];
    quantity: number;
    rate: number;
    amount: number;
    cost: any;
    costItems: any;
    costOverheads: any;
    [key: string]: any; // Index signature
}

interface Product {
    id_products: number;
    product_name: string;
}

interface ProductionData {
    idProductions: number | null;
    idProjects: number;
    idWarehouses?: number;
    projectName: string;
    date: string;
    referenceNo: string;
}


// Add warehouse dropdown state
const ManufacturingCreate = () => {
    const [warehouses, setWarehouses] = useState([]);
    const [warehouse, setWarehouse] = useState({ label: 'Select Warehouse', value: '' });

    const { idProductions }: RouteParams = useParams();

    let history = useHistory();
    const productionData: ProductionData = {
        idProductions: null,
        projectName: '',
        idProjects: 0,
        idWarehouses: 0,
        date: '',
        referenceNo: '',
    };

    const [configurationProduct, setConfigurationProduct] = useState<ProductionRows>();
    const [configurationBom, setConfigurationBom] = useState<ProductBomOption | null>(null);
    const [production, setProduction] = useState(productionData);
    const [products, setProducts] = useState<Product[]>([]);
    const [projects, setProjects] = useState([]);
    const [project, setProject] = useState({ label: 'Select Project', value: '' });
    const [inventoryHardMaintain, setInventoryHardMaintain] = useState('No');
    const [show, setShow] = useState(false);
    const handleClose = () => {
        setShow(false);
        setConfigurationBom(null);
    }

    const getBomId = (bom: any) => bom.id_product_boms ?? bom.idProductBoms;
    const getBomName = (bom: any) => bom.bom_name ?? bom.bomName ?? 'BOM';

    const fetchProductBoms = async (idProducts: number): Promise<ProductBomOption[]> => {
        const response = await fetch(
            `${process.env.REACT_APP_API_URL}product-boms/${idProducts}`,
            getRequestOptions()
        );
        const resp = await response.json();
        return (resp.data || []).map((bom: any) => ({
            label: getBomName(bom),
            value: getBomId(bom),
        }));
    };

    const fetchBomCostData = async (idProducts: number, idProductBoms: number, effectiveDate: string) => {
        const response = await fetch(
            `${process.env.REACT_APP_API_URL}products/${idProducts}?id_product_bom=${idProductBoms}&effective_date=${effectiveDate}`,
            getRequestOptions()
        );
        return response.json();
    };

    const fetchWarehouseStockForItems = async (idItems: number[], idProjects: number, idWarehouses: number) => {
        if (!idItems.length || !idProjects || !idWarehouses) {
            return {};
        }
        const response = await fetch(
            `${process.env.REACT_APP_API_URL}item/warehouse-stock`,
            postRequestOptions({ idItems, idProjects, idWarehouses })
        );
        const resp = await response.json();
        return resp.success ? (resp.data || {}) : {};
    };

    const attachWarehouseStock = async (costItems: any[], idProjects: number, idWarehouses: number) => {
        const idItems = costItems.map((item) => item.id_items).filter(Boolean);
        const stockMap = await fetchWarehouseStockForItems(idItems, idProjects, idWarehouses);
        return costItems.map((item) => ({
            ...item,
            warehouse_stock: stockMap[item.id_items] !== undefined ? parseFloat(stockMap[item.id_items]) : null,
        }));
    };

    const showMissingRateError = (resp: any) => {
        const missingNames = (resp.missingItems || []).map((item: any) => item.itemName).join('<br>');
        Swal.fire({
            icon: 'error',
            title: 'Average Rate Missing',
            html: missingNames
                ? `Average rate not found for the following items as of the manufacturing date:<br><br>${missingNames}`
                : (resp.message || 'Average rate not found for one or more items.'),
        });
    };

    const mapCostResponseToRowFields = (resp: any) => {
        const costItems = (resp.items || []).map((item: any) => ({
            id_items: item.idItems,
            item_name: item.itemName,
            category_name: item.categoryName,
            unit_name: item.unitName,
            without_loss_quantity: parseFloat(item.quantity),
            weighted_loss: 0,
            quantity: parseFloat(item.quantity),
            rate: parseFloat(item.rate),
            amount: parseFloat(item.amount),
            warehouse_stock: null,
        }));
        const costOverheads = (resp.overheads || []).map((overhead: any) => ({
            id_overheads: overhead.idOverheads,
            overhead_name: overhead.overheadName,
            amount: parseFloat(overhead.amount),
        }));

        const itemCost = costItems.reduce((sum: number, item: any) => sum + parseFloat(item.amount || 0), 0);
        const overheadCost = costOverheads.reduce((sum: number, overhead: any) => sum + parseFloat(overhead.amount || 0), 0);
        const vat = parseFloat(resp.data?.vat || 0);
        const totalCost = parseFloat((itemCost + overheadCost + vat).toFixed(2));

        const cost = {
            weighted_loss: parseFloat(resp.data?.weightedLoss || 0),
            vat,
            item_cost: parseFloat(itemCost.toFixed(2)),
            overhead_cost: parseFloat(overheadCost.toFixed(2)),
            total_cost: totalCost,
        };

        return {
            cost,
            costItems,
            costOverheads,
            rate: totalCost,
        };
    };

    const applyBomCostToRow = async (row: ProductionRows, effectiveDate: string): Promise<ProductionRows | null> => {
        if (!row.idProducts || !row.idProductBoms || !effectiveDate) {
            return row;
        }

        const resp = await fetchBomCostData(row.idProducts, row.idProductBoms, effectiveDate);
        if (!resp.success) {
            showMissingRateError(resp);
            return null;
        }

        const mapped = mapCostResponseToRowFields(resp);
        const updatedRow = {
            ...row,
            cost: mapped.cost,
            costItems: mapped.costItems,
            costOverheads: mapped.costOverheads,
            rate: mapped.rate,
            amount: parseFloat((row.quantity * mapped.rate).toFixed(2)),
        };

        return updatedRow;
    };

    const normalizeProductionRow = (row: ProductionRows): ProductionRows => {
        const cost = row.cost || {};
        const vat = parseFloat(cost.vat ?? row.vat ?? 0);
        const rate = parseFloat(
            row.rate ?? cost.total_cost ?? ((parseFloat(row.production_cost ?? 0)) + vat)
        );

        return {
            ...row,
            idProducts: row.idProducts ?? row.id_products ?? 0,
            productName: row.productName ?? row.product_name ?? '',
            packing: row.packing,
            size: row.size,
            quantity: parseFloat(row.quantity ?? 0),
            rate,
            amount: parseFloat(row.amount ?? (rate * parseFloat(row.quantity ?? 0))),
            cost: {
                weighted_loss: parseFloat(cost.weighted_loss ?? 0),
                vat,
                item_cost: parseFloat(cost.item_cost ?? 0),
                overhead_cost: parseFloat(cost.overhead_cost ?? 0),
                total_cost: parseFloat(cost.total_cost ?? rate),
            },
            costItems: (row.costItems || []).map((item: any) => ({
                ...item,
                rate: parseFloat(item.rate),
                quantity: parseFloat(item.quantity),
                without_loss_quantity: parseFloat(item.without_loss_quantity ?? item.quantity),
                weighted_loss: parseFloat(item.weighted_loss ?? 0),
                amount: parseFloat(item.amount),
            })),
            costOverheads: (row.costOverheads || []).map((overhead: any) => ({
                ...overhead,
                amount: parseFloat(overhead.amount),
            })),
            item: {
                item_name: row.item?.item_name ?? row.item_name ?? '',
                item_code: row.item?.item_code ?? row.item_code ?? '',
                unit: {
                    unit_name: row.item?.unit?.unit_name ?? row.unit_name ?? '',
                    id_units: row.item?.unit?.id_units ?? row.id_units,
                },
            },
        };
    };

    const enrichProductionRowWithBomMeta = async (row: ProductionRows): Promise<ProductionRows> => {
        const normalizedRow = normalizeProductionRow(row);
        if (!normalizedRow.idProducts) {
            return normalizedRow;
        }

        const bomOptions = await fetchProductBoms(normalizedRow.idProducts);
        const idProductBoms = normalizedRow.idProductBoms ?? normalizedRow.id_product_boms ?? bomOptions[0]?.value ?? null;
        const selectedBom = bomOptions.find((option) => option.value === Number(idProductBoms)) || bomOptions[0] || null;

        return {
            ...normalizedRow,
            bomOptions,
            idProductBoms: selectedBom?.value ?? null,
            bomName: selectedBom?.label ?? normalizedRow.bomName ?? '',
        };
    };

    // Fetch warehouses by project
    const getWarehousesByProject = (idProjects: number) => {
        if (!idProjects) {
            setWarehouses([]);
            setWarehouse({ label: 'Select Warehouse', value: '' });
            return;
        }
        fetch(
            process.env.REACT_APP_API_URL + 'warehouse/' + idProjects + '/list',
            getRequestOptions()
        )
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.success && Array.isArray(resp.data)) {
                    const whOptions = resp.data.map((item: any) => ({
                        label: item.name,
                        value: item.id_warehouses
                    }));
                    setWarehouses(whOptions);
                } else {
                    setWarehouses([]);
                }
                setWarehouse({ label: 'Select Warehouse', value: '' });
            })
            .catch(() => {
                setWarehouses([]);
                setWarehouse({ label: 'Select Warehouse', value: '' });
            });
    };

    const handleWarehouseChange = (selected: any) => {
        setWarehouse(selected);
        setProduction({ ...production, idWarehouses: selected ? selected.value : '' });
    };

    const handleProjectChange = (projectOption: any) => {
        setProject(projectOption);
        setInventoryHardMaintain(projectOption.inventoryHardMaintain || 'No');
        setProduction({ ...production, idProjects: projectOption.value });
        getProducts(projectOption.value);
        getWarehousesByProject(projectOption.value);
        setWarehouse({ label: 'Select Warehouse', value: '' });
        setProductionRows([{
            indexKey: null,
            idProducts: 0,
            idProductBoms: null,
            bomName: '',
            bomOptions: [],
            quantity: 0,
            rate: 0,
            amount: 0,
            cost: null,
            costItems: null,
            costOverheads: null,
        }]);
    };

    useEffect(() => {
        getProjects();
        if (idProductions) {
            fetch(
                process.env.REACT_APP_API_URL + 'manufacturing/edit/' + idProductions,
                getRequestOptions()
            )
                .then((resp) => resp.json())
                .then(async (resp) => {
                    setProduction(resp.production);
                    setProject({ value: resp.production.idProjects, label: resp.production.projectName });
                    getProducts(resp.production.idProjects);
                    getWarehousesByProject(resp.production.idProjects);
                    if (resp.production.idWarehouses) {
                        setWarehouse({ label: resp.production.warehouseName || 'Select Warehouse', value: resp.production.idWarehouses });
                    }

                    const enrichedRows = await Promise.all(
                        (resp.data || []).map(async (row: ProductionRows) => {
                            const withBom = await enrichProductionRowWithBomMeta(row);
                            if (withBom.idProducts && withBom.idProductBoms && resp.production.date) {
                                const withCost = await applyBomCostToRow(withBom, resp.production.date);
                                return withCost || withBom;
                            }
                            return withBom;
                        })
                    );
                    setProductionRows(enrichedRows);
                })
                .catch((error) => {
                    console.log(error, 'catch the hoop');
                });
        }
    }, []);

    const handleItemChange = async (data: any, index: number) => {
        if (!production.date) {
            Swal.fire({
                icon: 'warning',
                title: 'Manufacturing Date Required',
                text: 'Please select a manufacturing date before choosing a product.',
            });
            return;
        }

        const updatedProductionRows = [...productionRows];
        const row = { ...updatedProductionRows[index] };

        row.idProducts = data.value;
        row.productName = data.product_name;
        row.packing = data.packing;
        row.size = data.size;
        row.item = data.item;

        try {
            const bomOptions = await fetchProductBoms(data.value);
            row.bomOptions = bomOptions;
            const firstBom = bomOptions[0] || null;

            if (firstBom) {
                row.idProductBoms = firstBom.value;
                row.bomName = firstBom.label;
                const resp = await fetchBomCostData(data.value, firstBom.value, production.date);
                if (!resp.success) {
                    showMissingRateError(resp);
                    updatedProductionRows[index] = {
                        ...updatedProductionRows[index],
                        idProducts: 0,
                        productName: '',
                        idProductBoms: null,
                        bomName: '',
                        bomOptions: [],
                        cost: null,
                        costItems: null,
                        costOverheads: null,
                        rate: 0,
                        amount: 0,
                    };
                    setProductionRows(updatedProductionRows);
                    return;
                }
                const mapped = mapCostResponseToRowFields(resp);
                row.cost = mapped.cost;
                row.costItems = mapped.costItems;
                row.costOverheads = mapped.costOverheads;
                row.rate = mapped.rate;
            } else {
                row.idProductBoms = null;
                row.bomName = '';
                row.cost = null;
                row.costItems = null;
                row.costOverheads = null;
                row.rate = data.production_cost || 0;
            }
        } catch (error) {
            console.log(error, 'catch the hoop');
        }

        row.amount = parseFloat((row.quantity * row.rate).toFixed(2));
        updatedProductionRows[index] = row;
        setProductionRows(updatedProductionRows);
    }

    const getProducts = (project: number) => {

        fetch(
            process.env.REACT_APP_API_URL + 'manufacturing/products?idProjects=' + project,
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {

                let products = resp.data.map((item: any) => {
                    const productName = item.product_name;
                    const packingUnit = item.packing + ' ' + (item.item?.unit?.unit_name || '');
                    item.label = item.product_code
                        ? productName + ' (' + packingUnit.trim() + ') Code: ' + item.product_code
                        : productName + ' (' + packingUnit.trim() + ')';
                    item.value = item.id_products;
                    item.unitRate = item.production_cost;
                    return item
                })
                setProducts(products);

            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    const getProjects = () => {
        fetch(
            process.env.REACT_APP_API_URL + 'lead/projects',
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                let projectObj = resp.data.map((item: any) => {
                    item.label = item.name;
                    item.value = item.id;
                    return item
                })
                setProjects(projectObj);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    // const [isSubmitDisable, setSubmitDisable] = useState(false);
    // const [loading, setLoading] = useState(false);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const updatedProductionRows = [...productionRows];
        updatedProductionRows[index][e.target.name] = e.target.value;
        updatedProductionRows[index].amount = parseFloat((updatedProductionRows[index].quantity * updatedProductionRows[index].rate).toFixed(2))
        setProductionRows(updatedProductionRows);
    }

    const deleteProduct = (index: number) => {
        const updatedProductionRows = [...productionRows];
        if (updatedProductionRows && updatedProductionRows[index]) {
            updatedProductionRows.splice(index, 1);
            setProductionRows(updatedProductionRows);
        }
    }

    const configureProduct = async (index: number) => {
        const row = productionRows[index];
        if (!row || !row.idProducts || !row.cost) {
            return;
        }

        let preparedRow = normalizeProductionRow({ ...row, indexKey: index });

        if (!preparedRow.bomOptions || preparedRow.bomOptions.length === 0) {
            preparedRow = await enrichProductionRowWithBomMeta(preparedRow);
            const updatedProductionRows = [...productionRows];
            updatedProductionRows[index] = preparedRow;
            setProductionRows(updatedProductionRows);
        }

        preparedRow.rate = parseFloat(preparedRow.rate);
        preparedRow.cost.weighted_loss = parseFloat(preparedRow.cost.weighted_loss);
        preparedRow.cost.vat = parseFloat(preparedRow.cost.vat);
        preparedRow.cost.item_cost = parseFloat(preparedRow.cost.item_cost);
        preparedRow.cost.overhead_cost = parseFloat(preparedRow.cost.overhead_cost);
        preparedRow.cost.total_cost = parseFloat(preparedRow.cost.total_cost);

        if (production.idProjects && production.idWarehouses && preparedRow.costItems?.length) {
            preparedRow.costItems = await attachWarehouseStock(
                preparedRow.costItems,
                Number(production.idProjects),
                Number(production.idWarehouses)
            );
        }

        setConfigurationProduct(preparedRow);
        setConfigurationBom(
            preparedRow.bomOptions?.find((option) => option.value === Number(preparedRow.idProductBoms))
            || preparedRow.bomOptions?.[0]
            || null
        );
        setShow(true);
    }

    const handleConfigurationBomChange = async (option: ProductBomOption | null) => {
        if (!option || !configurationProduct) {
            return;
        }

        if (Number(option.value) === Number(configurationProduct.idProductBoms)) {
            setConfigurationBom(option);
            return;
        }

        if (!production.date) {
            Swal.fire({
                icon: 'warning',
                title: 'Manufacturing Date Required',
                text: 'Please select a manufacturing date before changing the BOM.',
            });
            return;
        }

        setConfigurationBom(option);

        try {
            const resp = await fetchBomCostData(configurationProduct.idProducts, option.value, production.date);
            if (!resp.success) {
                showMissingRateError(resp);
                return;
            }
            const mapped = mapCostResponseToRowFields(resp);
            let costItems = mapped.costItems;
            if (production.idProjects && production.idWarehouses) {
                costItems = await attachWarehouseStock(
                    costItems,
                    Number(production.idProjects),
                    Number(production.idWarehouses)
                );
            }
            setConfigurationProduct({
                ...configurationProduct,
                idProductBoms: option.value,
                bomName: option.label,
                cost: mapped.cost,
                costItems,
                costOverheads: mapped.costOverheads,
                rate: mapped.rate,
                amount: parseFloat((configurationProduct.quantity * mapped.rate).toFixed(2)),
            });
        } catch (error) {
            console.log(error, 'catch the hoop');
        }
    }

    const handleConfigurationUpdate = () => {
        if (!configurationProduct || configurationProduct.indexKey === null || configurationProduct.indexKey === undefined) {
            handleClose();
            return;
        }

        const updatedProduct: ProductionRows = {
            ...configurationProduct,
            idProductBoms: configurationBom?.value ?? configurationProduct.idProductBoms,
            bomName: configurationBom?.label ?? configurationProduct.bomName,
        };

        const updatedProductionRows = [...productionRows];
        updatedProductionRows[configurationProduct.indexKey] = updatedProduct;
        setProductionRows(updatedProductionRows);
        handleClose();
    }

    const buildLowStockHtml = (lowStockProducts: any[]) => {
        return lowStockProducts.map((product: any) => {
            const shortageLines = (product.shortages || []).map((shortage: any) =>
                `- ${shortage.itemName}: required ${shortage.required}, available ${shortage.available}`
            ).join('<br>');
            return `<b>${product.productName} (Qty: ${product.quantity})</b><br>${shortageLines}`;
        }).join('<br><br>');
    };

    const productionSave = async (event: any) => {
        event.preventDefault()

        if (inventoryHardMaintain === 'Yes') {
            try {
                const stockResponse = await fetch(
                    `${process.env.REACT_APP_API_URL}manufacturing/stock-check`,
                    postRequestOptions({ production, productionRows })
                );
                const stockData = await stockResponse.json();
                if (!stockData.success && stockData.lowStockProducts?.length) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Insufficient Stock',
                        html: `The following products cannot be manufactured due to insufficient raw material stock in the selected warehouse:<br><br>${buildLowStockHtml(stockData.lowStockProducts)}`,
                    });
                    return;
                }
            } catch (error) {
                console.log(error, 'catch the hoop');
            }
        }

        const confirm = await Swal.fire({
            title: 'Are you sure?',
            text: (idProductions === undefined) ? "You want to manufacture this Production?" : "You want to update this Production?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ec008c',
            cancelButtonText: 'Cancel',
            confirmButtonText: (idProductions === undefined) ? 'Yes, Manufacture it!' : 'Yes, Update',
        })

        if (confirm.value) {
            const postData = {
                production: production,
                productionRows: productionRows,
            }
            const requestOptions = postRequestOptions(postData)
            try {

                let url = (idProductions === undefined) ? `${process.env.REACT_APP_API_URL}manufacturing` : `${process.env.REACT_APP_API_URL}manufacturing/update/${idProductions}`
                let response = await fetch(
                    url,
                    requestOptions
                )
                let respData = await response.json()
                if (respData.success === true) {
                    const successMsg = respData.successMessage
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: successMsg,
                    })

                    history.push("/manufacturing");
                } else {
                    const errorsMessage = validationErrorMsg(respData.errors).join('<br>')
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        html: errorsMessage,
                    })
                }
                // setSubmitDisable(false);
                // setLoading(false);
            } catch (error) {
                console.log(error, 'catch the hoop')
                // setSubmitDisable(false);
                // setLoading(false);
            }
        }
    }

    const addProduct = () => {
        const newRow: ProductionRows = {
            indexKey: null,
            idProducts: 0,
            idProductBoms: null,
            bomName: '',
            bomOptions: [],
            quantity: 0,
            rate: 0,
            amount: 0,
            cost: null,
            costItems: null,
            costOverheads: null,
        };

        const updatedRows = [...productionRows];
        updatedRows.push(newRow);

        setProductionRows(updatedRows);
    }

    const handleInputOnChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setProduction({ ...production, [name]: value });

        if (name === 'date' && value) {
            const updatedRows = await Promise.all(
                productionRows.map(async (row) => {
                    if (!row.idProducts || !row.idProductBoms) {
                        return row;
                    }
                    const updated = await applyBomCostToRow(row, value);
                    return updated || row;
                })
            );
            setProductionRows(updatedRows);
        }
    }


    const handleProductInputOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;

        if (configurationProduct) {
            const updatedCost = {
                ...configurationProduct.cost,
                [name]: parseFloat(value)
            };

            const updatedProduct = {
                ...configurationProduct,
                cost: {
                    ...configurationProduct.cost,
                    ...updatedCost
                }
            };

            var netAmount = updatedProduct.cost.item_cost + updatedProduct.cost.overhead_cost + updatedProduct.cost.vat;
            updatedProduct.cost.total_cost = netAmount;
            updatedProduct.rate = netAmount;
            updatedProduct.amount = parseFloat((updatedProduct.quantity * netAmount).toFixed(2));

            setConfigurationProduct(updatedProduct);

            const updatedProductionRows = [...productionRows];
            updatedProductionRows[updatedProduct.indexKey] = updatedProduct
            setProductionRows(updatedProductionRows);
        }
    }

    const [productionRows, setProductionRows] = useState<ProductionRows[]>([{
        indexKey: null,
        idProducts: 0,
        idProductBoms: null,
        bomName: '',
        bomOptions: [],
        quantity: 0,
        rate: 0,
        amount: 0,
        cost: null,
        costItems: null,
        costOverheads: null,
    }]);

    useEffect(() => {
        if (project.value && projects.length) {
            const selectedProject = projects.find((p: any) => p.value === project.value);
            if (selectedProject) {
                setInventoryHardMaintain(selectedProject.inventoryHardMaintain || 'No');
            }
        }
    }, [projects, project.value]);

    useEffect(() => {
        if (!show || !configurationProduct?.costItems?.length || !production.idProjects || !production.idWarehouses) {
            return;
        }

        const refreshModalStock = async () => {
            if (!configurationProduct || !production.idProjects || !production.idWarehouses) {
                return;
            }
            const costItems = await attachWarehouseStock(
                configurationProduct.costItems,
                Number(production.idProjects),
                Number(production.idWarehouses)
            );
            setConfigurationProduct((prev) => prev ? { ...prev, costItems } : prev);
        };

        refreshModalStock();
    }, [production.idWarehouses, show]);

    const handleItemDataChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {

        if (configurationProduct) {

            let totalAmount = 0;
            const updatedProduct = {
                ...configurationProduct,
                costItems: configurationProduct.costItems.map((item: any, i: number) => {

                    if (i === index) {

                        let amount;
                        let quantity;
                        if (e.target.name === 'weighted_loss') {
                            quantity = item.without_loss_quantity + (item.without_loss_quantity * parseFloat(e.target.value)) / 100;
                            amount = item.rate * quantity
                        } else if (e.target.name === 'without_loss_quantity') {
                            quantity = parseFloat(e.target.value) + (parseFloat(e.target.value) * item.weighted_loss) / 100;
                            amount = item.rate * quantity;
                        } else {
                            quantity = item.quantity;
                            amount = item.quantity * item.rate;
                        }
                        totalAmount += amount;
                        return {
                            ...item,
                            [e.target.name]: e.target.value,
                            amount: amount.toFixed(2),
                            quantity: quantity,
                        };

                    } else {
                        totalAmount += parseFloat(item.amount);
                    }
                    return item;
                })
            };

            updatedProduct.cost.item_cost = totalAmount;
            var netAmount = updatedProduct.cost.item_cost + updatedProduct.cost.overhead_cost + updatedProduct.cost.vat;
            updatedProduct.cost.total_cost = netAmount;
            updatedProduct.rate = netAmount;
            updatedProduct.amount = parseFloat((updatedProduct.quantity * netAmount).toFixed(2));
            setConfigurationProduct(updatedProduct);

            const updatedProductionRows = [...productionRows];
            updatedProductionRows[updatedProduct.indexKey] = updatedProduct
            setProductionRows(updatedProductionRows);
        }
    }

    const handleOverheadDataChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {

        if (configurationProduct) {

            let totalAmount = 0;
            const updatedProduct = {
                ...configurationProduct,
                costOverheads: configurationProduct.costOverheads.map((item: any, i: number) => {

                    if (i === index) {
                        totalAmount += parseFloat(e.target.value);
                        return {
                            ...item,
                            [e.target.name]: e.target.value
                        };
                    } else {
                        totalAmount += parseFloat(item.amount);
                    }
                    return item;
                })
            };
            updatedProduct.cost.overhead_cost = totalAmount;
            var netAmount = updatedProduct.cost.item_cost + updatedProduct.cost.overhead_cost + updatedProduct.cost.vat;
            updatedProduct.cost.total_cost = netAmount;
            updatedProduct.rate = netAmount;
            updatedProduct.amount = parseFloat((updatedProduct.quantity * netAmount).toFixed(2));
            setConfigurationProduct(updatedProduct);
            const updatedProductionRows = [...productionRows];
            updatedProductionRows[updatedProduct.indexKey] = updatedProduct
            setProductionRows(updatedProductionRows);
        }
    }



    return (

        <div className="card card-custom">
            <div className="card-header">
                <div className="card-title">
                    <KTSVG
                        path='/media/svg/icons/Home/Book-open.svg'
                        className='svg-icon-1 svg-icon-primary'
                    />
                    <span className="text fw-bolder" style={{ marginLeft: "10px" }}>
                        {idProductions === undefined &&
                            <span>Create New Manufacturing Process</span>
                        }
                        {idProductions !== undefined &&
                            <span>Edit Manufacturing Data (ID # {idProductions})</span>
                        }
                    </span>
                </div>
            </div>

            <div className="ml-12">
                <div className="card-body">
                    {/* <pre>{JSON.stringify(productionRows, null, 2)}</pre> */}
                    <form onSubmit={productionSave}>


                        <div className="form-group row">
                            <label htmlFor="idProjects" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Select Project <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <Select
                                    value={project}
                                    onChange={handleProjectChange}
                                    options={projects}
                                    menuPosition="fixed"
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="idWarehouses" className="col-lg-3 col-form-label" style={{ textAlign: "right" }}>Select Warehouse <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <Select
                                    value={warehouse}
                                    onChange={handleWarehouseChange}
                                    options={warehouses}
                                    menuPosition="fixed"
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    isDisabled={warehouses.length === 0}
                                />
                            </div>
                        </div>

                        <div className="form-group row">
                            <label htmlFor="date" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Manufacturing Date  <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <input type='date' name="date" id="date" value={production.date} onChange={handleInputOnChange} className="form-control form-control-sm" />
                            </div>
                        </div>
                        <div className="form-group row mb-2">
                            <label htmlFor="referenceNo" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Batch No  <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <input name="referenceNo" id="referenceNo" value={production.referenceNo} onChange={handleInputOnChange} className="form-control form-control-sm" />
                            </div>
                        </div>

                        <div className="form-group row mb-2">
                            <div className="col text-end">
                                <button type='button' className="btn btn-success btn-sm px-2 py-1" onClick={() => addProduct()}>
                                    <KTSVG path='/media/svg/icons/Navigation/Plus.svg' className='svg-icon-5 svg-icon-danger me-0' /> Add More Product
                                </button>
                            </div>
                        </div>
                        <br></br>
                        <Table size='sm' bordered hover>
                            <thead>
                                <tr>
                                    <th style={{ width: '5%' }} className='text-center'>SL</th>
                                    <th style={{ width: '28%' }}>Product Name <span className="text-danger">*</span></th>
                                    <th style={{ width: '12%' }}>BOM Name</th>
                                    <th style={{ width: '13%' }}>Production Cost/Per Unit</th>
                                    <th style={{ width: '13%' }}>Production Quantity</th>
                                    <th style={{ width: '13%' }}>Total Cost</th>
                                    <th style={{ width: '16%' }}></th>
                                </tr>
                            </thead>

                            <tbody>

                                {productionRows.map((row, index) => (
                                    <tr key={index}>
                                        <td className='text-center'>{index + 1}</td>
                                        <td>
                                            <Select
                                                // value={row.idProducts}
                                                value={products.find((product) => product.value === row.idProducts) || null}
                                                defaultValue={{ 'label': row.productName, 'value': row.idProducts }}
                                                // placeholder={row.product_name + ' (Size: ' + row.packing + ')'}
                                                onChange={(selectedOption) => handleItemChange(selectedOption, index)}
                                                options={products}
                                                className='sm'
                                                menuPosition="fixed"
                                                styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        height: '32px',
                                                        minHeight: '32px',
                                                    }),
                                                    container: (provided, state) => ({
                                                        ...provided,
                                                        height: '32px',
                                                    }),
                                                }}
                                                // Custom label formatting
                                                formatOptionLabel={(data) => (
                                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                        <span>{data.label} <small style={{ color: '#888' }}>{data.alternateName}</small></span>
                                                    </div>
                                                )}
                                                filterOption={(option, inputValue) => {
                                                    const labelMatch = option.label.toLowerCase().includes(inputValue.toLowerCase());
                                                    const helpTextMatch = option.data.alternateName?.toLowerCase().includes(inputValue.toLowerCase());
                                                    return labelMatch || helpTextMatch;
                                                }}
                                            />
                                        </td>
                                        <td>{row.bomName || '-'}</td>
                                        <td>
                                            <input type="number" name="rate" readOnly value={row.rate} onChange={(event) => handleChange(event, index)} className="form-control form-control-sm" />
                                        </td>
                                        <td>
                                            <input type="number" name="quantity" value={row.quantity} onChange={(event) => handleChange(event, index)} className="form-control form-control-sm" />
                                        </td>
                                        <td>
                                            <input type="number" name="amount" readOnly value={row.amount} className="form-control form-control-sm" />
                                        </td>
                                        <td>
                                            <button type='button' className="btn btn-light-primary btn-sm px-2 py-1" onClick={() => deleteProduct(index)}>
                                                <KTSVG path='/media/svg/icons/General/Trash.svg' className='svg-icon-5 svg-icon-danger me-0' />
                                            </button>
                                            {row.idProducts !== 0 && row.cost &&
                                                <button type='button' className="btn btn-primary btn-sm px-2 py-1" onClick={() => configureProduct(index)}>
                                                    <KTSVG path='/media/svg/icons/General/Settings-2.svg' className='svg-icon-5 svg-icon-danger me-0' /> Cost Configuration
                                                </button>
                                            }

                                        </td>
                                    </tr>
                                ))}

                            </tbody>

                        </Table>
                        <div className="row mt-4">
                            <div className="col-12 text-center">
                                <button type="submit" className="btn btn-sm btn-success me-2">
                                    {idProductions === undefined &&
                                        <><KTSVG path='/media/svg/icons/Navigation/Right-2.svg' className='svg-icon-5 svg-icon-danger me-0' />Start Manufacturing</>
                                    }
                                    {idProductions !== undefined &&
                                        <><KTSVG path='/media/svg/icons/Navigation/Right-2.svg' className='svg-icon-5 svg-icon-danger me-0' />Update Manufacturing Data</>
                                    }
                                </button>
                                <Link to='/manufacturing' type="reset" className="btn btn-sm btn-secondary">Cancel</Link>
                            </div>
                        </div>

                    </form>

                    {/* <pre>{JSON.stringify(productionRows, null, 2)}</pre> */}

                </div>
            </div>

            {configurationProduct != null &&
                <>
                    <Modal show={show} onHide={() => handleClose()} size="xl">
                        <Modal.Header closeButton>
                            <Modal.Title>Configure Product Cost</Modal.Title>
                        </Modal.Header>
                        {/* <Form onSubmit={handleSubmit}> */}
                        <Modal.Body>


                            <Table size='sm' bordered hover>
                                <tr>
                                    <td width={'30%'}>Product Name </td>
                                    <td width={'70%'}> : {configurationProduct.productName}</td>
                                </tr>
                                <tr>
                                    <td>Product Code </td>
                                    <td> : {configurationProduct.item.item_code}</td>
                                </tr>
                                <tr>
                                    <td>Pack Size </td>
                                    <td> : {configurationProduct.size + ' ' + configurationProduct.item.unit.unit_name}</td>
                                </tr>
                                <tr>
                                    <td>BOM Name</td>
                                    <td>
                                        {(configurationProduct.bomOptions || []).length > 0 ? (
                                            <Select
                                                value={configurationBom}
                                                onChange={(option: ProductBomOption | null) => handleConfigurationBomChange(option)}
                                                options={configurationProduct.bomOptions || []}
                                                placeholder="Select BOM"
                                                menuPosition="fixed"
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        height: '32px',
                                                        minHeight: '32px',
                                                    }),
                                                    container: (provided) => ({
                                                        ...provided,
                                                        height: '32px',
                                                    }),
                                                }}
                                            />
                                        ) : (
                                            <span>{configurationProduct.bomName || '-'}</span>
                                        )}
                                    </td>
                                </tr>

                            </Table>


                            <Table size='sm' bordered hover>
                                <thead>
                                    <tr>
                                        <th className="col-1">Item</th>
                                        <th className="col-1">Category</th>
                                        <th className="col-1">Unit</th>
                                        <th className="col-1">Weighted Loss (%)</th>
                                        <th className="col-1">Quantity</th>
                                        <th className="col-1">Effective Quantity</th>
                                        <th className="col-1">Warehouse Stock</th>
                                        <th className="col-2">Rate</th>
                                        <th className="col-2">Amount</th>
                                        <th className="col-1">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {configurationProduct.costItems.map((productItem: any, index: number) => (
                                        <tr key={'item' + index}>
                                            <td className='text-left'>{productItem.item_name}</td>
                                            <td>{productItem.category_name}</td>
                                            <td>{productItem.unit_name}</td>
                                            <td>
                                                <input type="number" name="weighted_loss" value={productItem.weighted_loss} onChange={(event) => handleItemDataChange(event, index)} className="form-control form-control-sm" />
                                            </td>
                                            <td>
                                                <input type="number" name="without_loss_quantity" value={productItem.without_loss_quantity} onChange={(event) => handleItemDataChange(event, index)} className="form-control form-control-sm" />
                                            </td>
                                            <td>
                                                <input readOnly type="number" name="quantity" value={productItem.quantity} className="form-control form-control-sm" />
                                            </td>
                                            <td>
                                                {productItem.warehouse_stock !== null && productItem.warehouse_stock !== undefined
                                                    ? productItem.warehouse_stock
                                                    : '-'}
                                            </td>
                                            <td>
                                                <input readOnly type="number" name="rate" value={productItem.rate} className="form-control form-control-sm" />
                                            </td>
                                            <td>
                                                <input type="number" name="amount" value={productItem.amount} readOnly className="form-control form-control-sm" />
                                            </td>
                                            <td>
                                                <button type='button' className="btn btn-light-primary btn-sm px-2 py-1" onClick={() => deleteItem(index)}>
                                                    <KTSVG path='/media/svg/icons/General/Trash.svg' className='svg-icon-5 svg-icon-danger me-0' />
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                    <tr>
                                        <td className='text-end' colSpan={8}><b>Total Item Cost : </b></td>
                                        <td>{configurationProduct.cost.item_cost}</td>
                                    </tr>
                                </tbody>
                            </Table>

                            <Table size='sm' bordered hover>
                                <thead>
                                    <tr>
                                        <th className="col-9">Ohverhead Name</th>
                                        <th className="col-2">Amount</th>
                                        <th className="col-1">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {configurationProduct.costOverheads.map((productOverhead: any, index: number) => (
                                        <tr key={'overhead' + index}>
                                            <td className='text-left'>
                                                {productOverhead.overhead_name}
                                            </td>
                                            <td>
                                                <input type="number" name="amount" value={productOverhead.amount} onChange={(event) => handleOverheadDataChange(event, index)} className="form-control form-control-sm" />
                                            </td>
                                            <td>
                                                <button type='button' className="btn btn-light-primary btn-sm px-2 py-1" onClick={() => deleteOverhead(index)}>
                                                    <KTSVG path='/media/svg/icons/General/Trash.svg' className='svg-icon-5 svg-icon-danger me-0' />
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                    <tr>
                                        <td className='text-end'><b>Total Overhead Cost : </b></td>
                                        <td>{configurationProduct.cost.overhead_cost}</td>
                                    </tr>
                                </tbody>
                            </Table>

                            <Table size='sm' bordered hover>

                                <tbody>
                                    <tr>
                                        <td className='text-end col-9'><b>VAT : </b></td>
                                        <td className='col-3'>
                                            <input type='number' name="vat" value={configurationProduct.cost.vat} onChange={handleProductInputOnChange} className="form-control form-control-sm" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className='text-end col-9'><b>Total Production Cost with VAT : </b></td>
                                        <td className='col-3'><b>{configurationProduct.cost.item_cost + configurationProduct.cost.overhead_cost + configurationProduct.cost.vat}</b></td>
                                    </tr>
                                </tbody>


                            </Table>
                        </Modal.Body>

                        <Modal.Footer>

                            {/* <button type="submit" className="btn btn-sm btn-primary me-2">
                                <span>  Submit</span>
                            </button> */}
                            <Button variant='primary' size="sm" onClick={handleConfigurationUpdate}>
                                Update
                            </Button>
                            <Button variant='secondary' size="sm" onClick={() => handleClose()}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>

                </>
            }

            {/* <Modal show={show} onHide={() => handleClose(false)} size="lg">
                <form onSubmit={assignedToSave}>
                    <Modal.Header closeButton>
                        <Modal.Title>Configure Cost for Product</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="form-group row">
                            <label htmlFor="idCompanies" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Select Assign To <span className="required text-danger"></span></label>
                            <div className="col-lg-7">

                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>

                        <button type="submit" className="btn btn-sm btn-primary me-2"><span>  Submit</span></button>
                        <Button variant='secondary' size="sm" onClick={() => handleClose(false)}>
                            Close
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal> */}

        </div>

    )
}

export default ManufacturingCreate
